<div class="cancel" (click)="btnClickedHandler()">
  <i class="fal fa-times-circle"></i>
</div>
